// -------------------------------------------------------------------< constants >-------------------------------------------------------------------
// const SET_LANGUAGE= 'SET_LANGUAGE';
const SUCCESS = "SUCCESS";
const ERROR = "ERROR";
const GENERAL_SHOW_COMPANY_SUCCESS = "GENERAL_SHOW_COMPANY_SUCCESS";
const GENERAL_SHOW_MODULES_SUCCESS = "GENERAL_SHOW_MODULES_SUCCESS";
const GENERAL_SHOW_TYPES_SUCCESS = "GENERAL_SHOW_TYPES_SUCCESS";
const GENERAL_SHOW_NOTIFICATIONS_SUCCESS = "GENERAL_SHOW_NOTIFICATIONS_SUCCESS";
const GENERAL_SHOW_GRAPH_SUCCESS = "GENERAL_SHOW_GRAPH_SUCCESS";
const GENERAL_SHOW_DEPARTMENT_SUCCESS = "GENERAL_SHOW_DEPARTMENT_SUCCESS";
// ----------------------------------------------------------------< action creators >----------------------------------------------------------------
/**
 *
 * @param {*} payload
 * @param {String} url
 * @return {{type: string, payload: *, source: *}}
 */
export function success(payload, url = "Unknown") {
  return {
    type: SUCCESS,
    payload,
    url,
  };
}

/**
 *
 * @param {*} payload
 * @param {String} url
 * @return {{type: string, payload: *, source: *}}
 */
export function error(payload, url = "Unknown") {
  return {
    type: ERROR,
    payload,
    url,
  };
}

/**
 *
 * @param {{data: Object}} payload
 * @return {{type: String, payload: Object}}
 * @private
 */
function _showCompanySuccess(payload) {
  return {
    type: GENERAL_SHOW_COMPANY_SUCCESS,
    payload: payload.data,
  };
}
/**
 *
 * @param {{data: Object}} payload
 * @return {{type: String, payload: Object}}
 * @private
 */
function _showGraphSuccess(payload, type) {
  return {
    type: GENERAL_SHOW_GRAPH_SUCCESS,
    payload: { data: payload.data, type: type },
  };
}
/**
 *
 * @param {{data: Object}} payload
 * @return {{type: String, payload: Object}}
 * @private
 */
function _showDepartmentSuccess(payload, type) {
  return {
    type: GENERAL_SHOW_DEPARTMENT_SUCCESS,
    payload: { data: payload.data, type: type },
  };
}

/**
 *
 * @param {{data: Object}} payload
 * @return {{type: String, payload: Object}}
 * @private
 */
function _showModulesSuccess(payload) {
  return {
    type: GENERAL_SHOW_MODULES_SUCCESS,
    payload: payload.data,
  };
}

/**
 *
 * @param {{data: Object}} payload
 * @return {{type: String, payload: Object}}
 * @private
 */
function _showTypesSuccess(payload) {
  return {
    type: GENERAL_SHOW_TYPES_SUCCESS,
    payload: payload.data,
  };
}

/**
 *
 * @param {{data: Object}} payload
 * @return {{type: String, payload: Object}}
 * @private
 */
function _showNotificationsSuccess(payload) {
  return {
    type: GENERAL_SHOW_NOTIFICATIONS_SUCCESS,
    payload: payload.data,
  };
}

// --------------------------------------------------------------------< actions >--------------------------------------------------------------------

// /**
//  * setting application's locale
//  * @param {string} language
//  * @return {{type: string, payload: *}}
//  */
// export function setLanguage(language) {
//   return {
//     type: SET_LANGUAGE,
//     payload: language,
//   };
// }

/**
 *
 * @param {Object} [sendBody]
 * @param {Function} [callback=(function())]
 * @return {Function}
 */
export function showGraph(qq, type, callback) {
  return (dispatch, gs, api) => {
    api
      .post(`/Dashboard/GetData`, { data: qq }) // ارسال مستقیم بدنه درخواست
      .then((res) => {
        console.log("Response:", res);
        dispatch(_showGraphSuccess(res, type));
        callback(undefined, res);
      })
      .catch((err) => {
        // callback(err);
      });
  };
}

/**
 *
 * @param {Object} [sendBody]
 * @param {Function} [callback=(function())]
 * @return {Function}
 */
export function getDepartments(qq, type, callback) {
  return (dispatch, gs, api) => {
    api
      .get(`/Dashboard/GetDepartments`) // ارسال مستقیم بدنه درخواست
      .then((res) => {
        console.log("Response:", res);
        dispatch(_showDepartmentSuccess(res, type));
        callback(undefined, res);
      })
      .catch((err) => {
        // callback(err);
      });
  };
}
// /**
//  *
//  * @param {Object} [sendBody]
//  * @param {Function} [callback=(function())]
//  * @return {Function}
//  */
// export function showGraph(qq, type, callback) {
//   console.log("@34234lineChart", qq.lineChart);
//   console.log("@34234barChart", qq.barChart);
//   switch (type) {
//     case "lineChart":
//       return (dispatch, gs, api) => {
//         api
//           .post(`/Dashboard/GetData`,  { data: qq?.lineChart }) // ارسال مستقیم بدنه درخواست
//           .then((res) => {
//             console.log("Response:", res);
//             dispatch(_showGraphSuccess(res, type));
//             callback(undefined, res);
//           })
//           .catch((err) => {
//             // callback(err);
//           });
//       };
//       break;
//     case "barChart":
//       return (dispatch, gs, api) => {
//         api
//           .post(`/Dashboard/GetData`, { data: qq?.barChart }) // ارسال مستقیم بدنه درخواست
//           .then((res) => {
//             console.log("Response:", res);
//             dispatch(_showGraphSuccess(res, type));
//             callback(undefined, res);
//           })
//           .catch((err) => {
//             // callback(err);
//           });
//       };
//       break;
//     default:
//       break;
//   }
// }

/**
 *
 * @param {Object} [params]
 * @param {Function} [callback=(function())]
 * @return {Function}
 */
export function showCompany(params = {}, callback = () => {}) {
  return (dispatch, gs, api) => {
    api
      .get("/companies", {
        filterGroup: [
          {
            filters: [
              {
                key: "company_id",
                value: null,
                operator: "eq",
              },
            ],
          },
        ],
        ...params,
      })
      .then((res) => {
        dispatch(_showCompanySuccess(res));
        localStorage.setItem("Company", res.data?.companies[0]?.name);
        localStorage.setItem("CompanyCode", res.data?.companies[0]?.code);

        callback(undefined, res);
      })
      .catch((err) => {
        callback(err);
      });
  };
}

/**
 *
 * @param {Object} [params]
 * @param {Function} [callback=(function())]
 * @return {Function}
 */
export function showModules(params = {}, callback = () => {}) {
  return (dispatch, gs, api) => {
    api
      .get("/modules", { params })
      .then((res) => {
        dispatch(_showModulesSuccess(res));
        callback(undefined, res);
      })
      .catch((err) => {
        callback(err);
      });
  };
}

/**
 *
 * @param {Object} [params]
 * @param {Function} [callback=(function())]
 * @return {Function}
 */
export function showTypes(params = {}, callback = () => {}) {
  return (dispatch, gs, api) => {
    api
      .get("/types", { params })
      .then((res) => {
        dispatch(_showTypesSuccess(res));
        callback(undefined, res);
      })
      .catch((err) => {
        callback(err);
      });
  };
}

/**
 *
 * @param {Object} [data]
 * @param {Object} [params]
 * @param {Function} [callback=(function())]
 * @return {Function}
 */
export function showNotification(data = {}, params = {}, callback = () => {}) {
  return (dispatch, gs, api) => {
    // api.get('/user/notifications', {data, params})
    //   .then((res) => {
    //     dispatch(_showNotificationsSuccess(res));
    //     callback(undefined, res);
    //   })
    //   .catch((err) => {
    //     callback(err);
    //   });
  };
}
/**
 *
 * @param {Number} [id]
 * @param {Object} [data]
 * @param {Object} [params]
 * @param {Function} [callback=(function())]
 * @return {Function}
 */
export function readNotification(
  id = 0,
  data = {},
  params = {},
  callback = () => {}
) {
  return (dispatch, gs, api) => {
    api
      .post(`/notifications/${id}/read`, { data, params })
      .then((res) => {
        callback(undefined, res);
      })
      .catch((err) => {
        console.log(err);
        callback(err);
      });
  };
}
// --------------------------------------------------------------------< reducer >--------------------------------------------------------------------

/**
 *
 * @param {object} state
 * @param {object} action
 * @return {object}
 */
export default function reducer(
  state = {
    // language: 'fa',
    company: {},
    modules: [],
    grouped_modules: [],
    types: [],
    grouped_types: [],
    notifications: [],
    LineChart: [],
    BarChart: [],
    PieChart: [],
    AdminSeasonalDelay: [],
    PersonMonthlyFunction: [],
    PersonWeeklyOvertime: [],
    PersonMonthlyAbsenceAndFraction: [],
    PersonWeeklyAbsenceAndDelayAndHurry: [],
    Department: [],
  },
  action
) {
  switch (action.type) {
    case GENERAL_SHOW_COMPANY_SUCCESS:
      return Object.assign({}, state, {
        company: action.payload.companies[0],
      });
    case GENERAL_SHOW_GRAPH_SUCCESS:
      console.log("action.payload.type", action.payload);

      switch (action.payload.type) {
        case "lineChart":
          return Object.assign({}, state, {
            LineChart: action.payload.data,
          });
          break;
        case "barChart":
          return Object.assign({}, state, {
            BarChart: action.payload.data,
          });
          break;
        case "pieChart":
          return Object.assign({}, state, {
            PieChart: action.payload.data,
          });
          break;
        case "stackedBarChart":
          return Object.assign({}, state, {
            StackedBarChart: action.payload.data,
          });
          break;
        case "adminRemainingLeave":
          return Object.assign({}, state, {
            AdminRemainingLeave: action.payload.data,
          });
          break;
        case "adminMonthlyOvertimeBasedOnDepartment":
          return Object.assign({}, state, {
            AdminMonthlyOvertimeBasedOnDepartment: action.payload.data,
          });
          break;
        case "adminSeasonalDelay":
          return Object.assign({}, state, {
            AdminSeasonalDelay: action.payload.data,
          });
          break;
        case "adminSeasonalLeaveBaseOnDepartment":
          return Object.assign({}, state, {
            AdminSeasonalLeaveBaseOnDepartment: action.payload.data,
          });
          break;
        case "personWeeklyAbsenceAndDelayAndHurry":
          return Object.assign({}, state, {
            PersonWeeklyAbsenceAndDelayAndHurry: action.payload.data,
          });
          break;
        case "personWeeklyOvertime":
          return Object.assign({}, state, {
            PersonWeeklyOvertime: action.payload.data,
          });
          break;
        case "personMonthlyAbsenceAndFraction":
          return Object.assign({}, state, {
            PersonMonthlyAbsenceAndFraction: action.payload.data,
          });
          break;
        case "personMonthlyReport":
          return Object.assign({}, state, {
            PersonMonthlyReport: action.payload.data,
          });
          break;
        case "personLastClocking":
          return Object.assign({}, state, {
            PersonLastClocking: action.payload.data,
          });
          break;
        case "personInCompleteMonthlyClocking":
          return Object.assign({}, state, {
            PersonInCompleteMonthlyClocking: action.payload.data,
          });
          break;
        case "adminDailyReport":
          return Object.assign({}, state, {
            AdminDailyReport: action.payload.data,
          });
          break;
        default:
          return;
          break;
      }
    case GENERAL_SHOW_DEPARTMENT_SUCCESS:
      return Object.assign({}, state, {
        Department: action.payload,
      });
    case GENERAL_SHOW_MODULES_SUCCESS:
      return Object.assign({}, state, {
        modules: action.payload.modules,
        grouped_modules: action.payload.modules.nest("moduleId"),
      });
    case GENERAL_SHOW_TYPES_SUCCESS:
      if (app.lang.locale === "en")
        for (const x of action.payload.types) x.label = x.name;

      return Object.assign({}, state, {
        types: action.payload.types,
        grouped_types: action.payload.types.nest("typeId"),
      });
    case GENERAL_SHOW_NOTIFICATIONS_SUCCESS:
      return Object.assign({}, state, {
        notifications: action.payload.notifications,
      });
    // case SET_LANGUAGE:
    //   return Object.assign(state, {
    //     language: action.payload.language,
    //   });
    default:
      return state;
  }
}
